import { S3_PATH_DISPLAY_NAME } from "../constants/config";

export const redactPIData = (message: string): string => {

    const allowlistNumbers: string[] = import.meta.env.VITE_ALLOW_PHONE_NUMBERS
        ? import.meta.env.VITE_ALLOW_PHONE_NUMBERS.split(",").map((num: string) => num.trim())
        : [];

    const regexPatterns: { [key: string]: RegExp } = {
        "NRIC/FIN": /\b[SFTGM]\d{7}[A-Z]\b/gi,
        // FIN: /\b[FGM]\d{7}[A-Z]\b/gi,
        "PASSPORT": /\b[A-Z]\d{7}[A-Z]?\b/gi,
        "CONTACT_NO": /(?:(?:\+?65|0?65?)?\s?)?(?:[689])\d{3}\s?\d{4}\b/gi,
        "EMAIL": /\b(?![A-Za-z0-9._%+-]+@moe\.edu\.sg)[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/gi
    };

    let redactedMessage = message;

    for (const key in regexPatterns) {
        if (key === "CONTACT_NO") {
            const matches = redactedMessage.match(regexPatterns[key]);
            if (matches) {
                matches.forEach((match) => {
                    if (!allowlistNumbers.includes(match)) {
                        console.log(match)
                        redactedMessage = redactedMessage.replace(match, "<CONTACT_NO>");
                    }
                });
            }
        } else {
            redactedMessage = redactedMessage.replace(regexPatterns[key], `<${key}>`);
        }
    }

    return redactedMessage;
};


export const trimWholeWordsPastLimit = (text: string, limit: number) => {
    if (text.length <= limit) {
        return text;
    }
    let trimmedText = text.slice(0, limit);
    let lastSpaceIndex = trimmedText.lastIndexOf(" ");
    if (lastSpaceIndex === -1) {
        return text.slice(0, limit - 3) + "...";
    }
    return trimmedText.slice(0, lastSpaceIndex) + "...";
}

// export const joinedDisplayNamesByIndexes = (strItems: string[], indexes: number[]) => {
//     let result = ""
//     indexes.forEach((i) => {
//         if (i < 0 || strItems.length <= i) return 'Invalid index'

//         if (S3_PATH_DISPLAY_NAME[strItems[i]]) {
//             result += S3_PATH_DISPLAY_NAME[strItems[i]] + ' '
//         } else {
//             result += strItems[i] + ' '
//         }
//     })
//     return result.trim()
// }

export async function* handleStreamResponse(response: Response) {
    let buffer = ''
    const decoder = new TextDecoder('utf-8');
    const reader = response.body?.getReader();
    for (; ;) {
        const { done, value } = await reader!.read()
        if (done) break;

        try {
            let decodedValue = decoder.decode(value);
            //if not json string and is base64 value
            if (decodedValue.indexOf("{") === -1) {
                decodedValue = atob(decodedValue);
            };
            // console.log("decodedValue", decodedValue)
            yield decodedValue
        }
        catch (e: any) {
            console.warn(e.message)
        }

    }
}

export const getScreenSize = () => {
    if (window.innerWidth < 768) return 1;
    if (window.innerWidth < 1024) return 2;
    return 3;
}